import React, { SVGProps } from 'react';

const RedeemCodeIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				d="M15.0375 3.00583L10.2584 3C10.0413 3.00011 9.82646 3.04324 9.62621 3.12692C9.42595 3.2106 9.24428 3.33316 9.09169 3.4875L2.98336 9.64917C2.67672 9.9609 2.50488 10.3807 2.50488 10.8179C2.50488 11.2552 2.67672 11.6749 2.98336 11.9867L8.46086 17.5125C8.61316 17.6672 8.79478 17.79 8.9951 17.8737C9.19542 17.9574 9.41042 18.0004 9.62752 18C9.84456 17.9999 10.0594 17.9568 10.2597 17.8731C10.4599 17.7894 10.6416 17.6668 10.7942 17.5125L16.9684 11.2817C17.1355 11.1262 17.269 10.9381 17.3604 10.7289C17.4519 10.5198 17.4994 10.2941 17.5 10.0658V5.4825C17.5005 4.82796 17.2416 4.19989 16.7801 3.73574C16.3186 3.27158 15.6921 3.00914 15.0375 3.00583ZM12.9942 8.37083C12.7732 8.37083 12.5612 8.28304 12.4049 8.12676C12.2487 7.97048 12.1609 7.75851 12.1609 7.5375C12.1609 7.31649 12.2487 7.10452 12.4049 6.94824C12.5612 6.79196 12.7732 6.70417 12.9942 6.70417C13.2152 6.70417 13.4272 6.79196 13.5834 6.94824C13.7397 7.10452 13.8275 7.31649 13.8275 7.5375C13.8275 7.75851 13.7397 7.97048 13.5834 8.12676C13.4272 8.28304 13.2152 8.37083 12.9942 8.37083Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default RedeemCodeIcon;
